const getInviteBodyText = (conferenceUrl: string): string => {
  const link = `<a href="${conferenceUrl}" target="_blank" id="LPNoLP">${conferenceUrl}</a>`; // LPNoLP - to disable link preview
  return `<br/>Присоединиться к конференции: ${link}`;
};

export default getInviteBodyText;
